module.exports = __webpack_public_path__ + "img/Size=20, Style=light.64473711.svg";